import {
  IRoleCreateProps,
  IRoleProps,
  IRoleSimpleProps,
  IRoleUpdateParams,
} from './types';
import { api } from '../DefaultService';

const ENDPOINT = 'v1/roles';

export const createRoleAsync = async (
  data: IRoleCreateProps,
): Promise<IRoleProps> => {
  return await api
    .post(ENDPOINT, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getRoleByIdAsync = async (id: number): Promise<IRoleProps> => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllRoleByLicenseAsync = async (): Promise<
  IRoleSimpleProps[]
> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateRoleAsync = async ({
  id,
  data,
}: IRoleUpdateParams): Promise<IRoleProps> => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteRoleAsync = async (id: number): Promise<void> => {
  await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};
